var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 6,
    viewBox: "0 0 18 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.16699H4.5L6.88235 1.83366H4.23529L6.08824 0.166992H1.05882L0 1.11937V2.78604L1.72059 1.23842H3.04412L2.38235 1.83366H1.85294L0.794118 2.78604H4.63235L3.70588 4.09556H1.05882L0 5.16699ZM6.88235 0.166992L5.55882 1.35747H7.41177L7.67647 1.11937H10.4559L11.5147 0.166992H6.88235ZM5.02941 5.16699L7.14706 2.30985H8.73529L7.41177 4.09556H11.3824L10.1912 5.16699H5.02941ZM11.25 1.11937L12.3088 0.166992H17.3382L15.3529 1.83366H18L15.75 5.16699H11.25L12.4412 4.09556H14.9559L15.8824 2.78604H12.0441L13.1029 1.83366H13.6324L14.2941 1.23842H13.1029L11.25 2.90509V1.11937Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBcb);
export default __webpack_public_path__ + "static/media/bcb.f4700f2bd62c403a5f0d6044509210c1.svg";
export { ForwardRef as ReactComponent };